var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComposerNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.25 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.25h9.5a1.25 1.25 0 0 1 1.25 1.25v10.5a1.25 1.25 0 0 1-1.25 1.25h-9.5a1.25 1.25 0 0 1-1.25-1.25V2.5A1.25 1.25 0 0 1 1.25 1.25z",
    fill: "none",
    stroke: "#a0a0a0",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1.25,
    x2: 4,
    y2: 14.25,
    stroke: "#a0a0a0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 5.5,
    x2: 10.75,
    y2: 5.5,
    stroke: "#a0a0a0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 8,
    x2: 10.75,
    y2: 8,
    stroke: "#a0a0a0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 10.5,
    x2: 9.25,
    y2: 10.5,
    stroke: "#a0a0a0",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposerNotesIcon);
export default __webpack_public_path__ + "static/media/composer-notes-icon.f6d48795c377004efe3f546938a8ad04.svg";
export { ForwardRef as ReactComponent };